import React, { useEffect, useState } from "react";
import { Accordion, CardDeck, Form, Spinner } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import logger from "../../../../utils/logger";
import { getTrack, loadTrack } from "../../../controller/reducer/track";
import { getLoading } from "../../../controller/reducer/ui";
import LocSelector from "../common/loc-selector";
import TrackCard from "./card";

function check(title, search) {
  // logger()(title, search);
  return search === "" || title === search;
}

const parse = (serLocation) => {
  if (serLocation === "") return "";
  const ser = serLocation.slice(1);
  const arr = ser.split("=");

  if (2 <= arr.length && arr[0] === "search") {
    return arr[1].split("_").join(" ");
  }
  return "";
};

const meta = (
  <Helmet>
    <title>{`CR21 | Live Bed Tracker`}</title>
    <meta
      name="description"
      content={
        "State and Union Territories based verfied bed tracking resources"
      }
    />
  </Helmet>
);

const TrackList = () => {
  const trackList = useSelector(getTrack);
  const [loc, setLoc] = useState(null);
  const dispatch = useDispatch();
  const { location } = useHistory();

  useEffect(() => {
    logger()(location.search);
    const search = parse(location.search);
    logger()(search);
    setLoc({ label: search, value: search });
  }, [location.search]);

  logger()(trackList);
  useEffect(() => {
    dispatch(loadTrack());
  }, [dispatch]);

  if (useSelector(getLoading))
    return (
      <Spinner
        style={{ position: "fixed", top: "50%", right: "47%" }}
        animation="border"
      >
        {meta}
      </Spinner>
    );

  return (
    <div>
      {meta}
      <div className="ml-4 mr-4 mt-4">
        <LocSelector loc={loc} setLoc={setLoc} />
        <Form.Text className="text-muted">
          Select your state to look for beds availability
        </Form.Text>
      </div>

      {trackList.length > 0 ? (
        <Accordion defaultActiveKey="0">
          <CardDeck className="m-4 justify-content-between">
            {trackList
              .filter((res) => check(res.name, loc ? loc.label : ""))
              .map((res, id) => (
                <TrackCard
                  key={id}
                  eventKey={(loc ? id : id + 1).toString()}
                  res={res}
                />
              ))}
          </CardDeck>
        </Accordion>
      ) : (
        <p className="ml-4 mr-4 mt-4 font-weight-normal">No Resources Found</p>
      )}
    </div>
  );
};

export default TrackList;
